module.exports = __webpack_public_path__ + "img/aParty_110923_J.a50404ee.jpg";